// Keyed 'brand-menu', not 'menu': the guest surface already owns 'menu' and
// the catalog manifest requires keys unique across surfaces.
export const brandMenuHandler = {
    pathPattern: '/brands/:brandId/menu',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/menu` }),
    meta: {
        title: 'Brand menu',
        description: 'Opens the menu list in the operator dashboard (Hermes brand.menu).',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'brandId', in: 'path', required: true }],
        example: { params: { brandId: 'BXqExampleBrandId' } },
    },
};
//# sourceMappingURL=brand-menu.js.map